import { useTranslation } from 'react-i18next';
import { useTabletAndDownQuery } from '../../hooks/useTabletAndDownQuery';
import { ContainerCard } from '../ContainerCard';
import { PersonCrossIcon } from '@navikt/aksel-icons';
import { Paragraph } from '../Paragraph';
import { Button } from '../Button';

import cn from 'classnames';
import classes from './DeleteConfirmationDialog.module.css';
import { SetStateAction, Dispatch, FragmentProps } from 'react';

type DeleteConfirmationDialogDialogProps = {
  setOpenDeleteConfirmationDialog: Dispatch<SetStateAction<boolean>>;
  onDeleteConfirmationDialog: () => void;
  title: string;
  text: FragmentProps['children'];
  isDeleting: boolean;
};

export const DeleteConfirmationDialog = ({
  setOpenDeleteConfirmationDialog,
  onDeleteConfirmationDialog,
  isDeleting,
  title,
  text,
}: DeleteConfirmationDialogDialogProps) => {
  const { t } = useTranslation();
  const isTabletAndDown = useTabletAndDownQuery();

  const containerClassNames = cn(classes.container, {
    [classes.noBorderRadius]: isTabletAndDown,
  });
  return (
    <ContainerCard className={containerClassNames}>
      <ContainerCard.Title
        icon={<PersonCrossIcon aria-hidden="true" fontSize="1.5rem" />}
      >
        {title}
      </ContainerCard.Title>
      <ContainerCard.Body className={classes.deleteConfirmationDialogBody}>
        <Paragraph size="lg">{text}</Paragraph>
        <div className={classes.buttonContainer}>
          <Button
            variant="danger"
            size="large"
            onClick={() => onDeleteConfirmationDialog()}
            disabled={isDeleting}
            aria-label={t('deleteConfirmationDialog.deleteAndClose')}
          >
            {isDeleting ? t('deleteConfirmationDialog.deleting') : t('deleteConfirmationDialog.deleteArticle')}
          </Button>
          <Button
            variant="secondary"
            size="large"
            onClick={() => setOpenDeleteConfirmationDialog(false)}
          >
            {t('deleteConfirmationDialog.cancel')}
          </Button>
        </div>
      </ContainerCard.Body>
    </ContainerCard>
  );
};
